import { Loader } from 'lucide-react'
import React from 'react'
import { twMerge } from 'tailwind-merge'

import { spinner } from '@ui-kit/components/Spinner/styles'
import { COLOR } from '@ui-kit/constants'

import type { Props } from './types'

const Spinner = (props: Props) => {
  const { container, loader, subContainer, spin } = spinner({
    size: props.size,
    isFullScreen: props.fullScreen,
  })
  return (
    <div data-testid={props.testID} className={container()}>
      <div className={twMerge(loader(), subContainer(), spin())}>
        <Loader color={COLOR[props.color ?? 'deepForest']} width={32} height={32} />
      </div>
    </div>
  )
}

export default Spinner
